import { Directive } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator } from "@angular/forms";
import { HelpService } from '../services/help.service';

@Directive({
    selector: '[validatorEmail]',
    providers: [{ provide: NG_VALIDATORS, useExisting: EmailValidatorDirective, multi: true }],
    standalone: false
})
export class EmailValidatorDirective implements Validator {

  constructor(private helpService: HelpService) { }

  validate(control: AbstractControl): ValidationErrors | null {
    if (control.value) {
      const validEmail = this.helpService.isEmailValid(control.value);
      return !validEmail ? { email: { value: control.value } } : null;
    } else {
      return null;
    }
  }

}
